export const DEFAULT_AUTH_REDIRECT = '/dashboard';
export const AUTH_ERROR_ROUTE = '/auth/error';
